import React, { useEffect } from 'react'
import { Radio, Badge } from 'antd'

export const Toggle = ({
    chatContext,
    setChatContext,
    caseId,
    handleMarkTicketAsRead,
    getChatWithUnreadPatientMessagesCount,
    caseTicketList,
    chatList
}) => {
    const adminUnreadCount = caseTicketList.find(ticket => ticket.caseId === caseId)?.unreadCount || 0
    const patientChat = chatList.find(chat => chat?.caseId === caseId)
    const patientUnreadCount = patientChat?.count || 0

    useEffect(() => {
        if (!patientChat && caseId) {
            getChatWithUnreadPatientMessagesCount(caseId)
        }
    }, [caseId, patientChat])

    useEffect(() => {
        if (chatContext === 'admin') {
            handleMarkTicketAsRead()
        }
    }, [chatContext])


    return (
        <div style={{
            width: '100%',
            height: '64px',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            padding: '10px 14px',
            position: 'absolute',
            zIndex: 2,
            background: 'linear-gradient(180deg, #fff 0%, #fff 65%, rgba(255, 255, 255, 0) 100%)',
            pointerEvents: 'none',
        }}>
            <Radio.Group
                id="messaging-chat-context-toggle"
                buttonStyle="solid"
                onChange={({ target }) => setChatContext(target.value)}
                value={chatContext}
                style={{
                    pointerEvents: 'auto',
                    background: '#fff',
                    borderRadius: 6,
                    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.12)',
                }}
            >
                <Badge count={patientUnreadCount}>
                    <Radio.Button id="messaging-chat-context-patient-radio" value={'patient'}>Patient</Radio.Button>
                </Badge>
                <Badge count={adminUnreadCount}>
                    <Radio.Button id="messaging-chat-context-admin-radio" value={'admin'}>Admin</Radio.Button>
                </Badge>
            </Radio.Group>
        </div>
    )
}
